module.exports = __webpack_public_path__ + "img/pentagon-logo.65fe7827.png";